define("settings/routes/groups/group/social_profiles", ["exports", "@ember/routing/route", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency-decorators", "later/utils/object-promise-proxy"], function (_exports, _route, _object, _service, _tracking, _emberConcurrencyDecorators, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _destroySocialProfile;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let SocialProfilesRoute = (_class = (_destroySocialProfile = /*#__PURE__*/new WeakSet(), class SocialProfilesRoute extends _route.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _destroySocialProfile);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "credentialStatus", _descriptor3, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor4, this);

      _initializerDefineProperty(this, "errors", _descriptor5, this);

      _initializerDefineProperty(this, "intl", _descriptor6, this);

      _initializerDefineProperty(this, "onboarding", _descriptor7, this);

      _initializerDefineProperty(this, "settings", _descriptor8, this);

      _initializerDefineProperty(this, "store", _descriptor9, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor10, this);

      _defineProperty(this, "queryParams", {
        new_social_profile_id: {
          refreshModel: true
        },
        profile: {
          refreshModel: true
        },
        nickname: {}
      });

      _initializerDefineProperty(this, "hasAuthedNewSocialProfile", _descriptor11, this);

      _initializerDefineProperty(this, "newSocialProfile", _descriptor12, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get canAccessProfileCategorizationAnalytics() {
      return this.currentAccount.canAccessProfileCategorizationAnalytics;
    }

    get instagramProfiles() {
      return this.currentAccount.instagramProfiles;
    }

    get numUsedSocialSets() {
      return this.auth.socialSets.filter(socialSet => socialSet.get('socialProfiles').length > 0).length;
    }

    get profileCatFlow() {
      if (!this.hasAuthedNewSocialProfile) {
        return null;
      }

      const {
        industry,
        isInstagram
      } = this.newSocialProfile || {};

      if (!isInstagram) {
        return null;
      }

      if ((!industry || this.onboarding.shouldStartOnboarding) && this.instagramProfiles.length === 1) {
        return 'profile_categorization';
      }

      if (this.canAccessProfileCategorizationAnalytics) {
        return 'new_profile';
      }

      return null;
    }

    get socialSetsRemaining() {
      const remaining = (this.totalSocialSets || 1) - this.numUsedSocialSets;
      return Math.max(remaining, 0);
    }

    get totalSocialSets() {
      return this.currentAccount.totalSocialSets || 1;
    }

    model(_ref) {
      let {
        new_social_profile_id,
        profile
      } = _ref;
      this.hasAuthedNewSocialProfile = !!new_social_profile_id;

      if (this.hasAuthedNewSocialProfile) {
        const socialProfile = this.store.peekRecord('social-profile', new_social_profile_id) || this.store.findRecord('social-profile', new_social_profile_id);
        this.newSocialProfile = socialProfile;
        return socialProfile;
      }

      if (!profile) {
        return undefined;
      }

      return this.store.peekRecord('social-profile', profile) || this.store.findRecord('social-profile', profile);
    }

    setupController(controller, model) {
      controller.setProperties({
        displayAdvanced: true,
        group: this.modelFor('groups.group'),
        showProfileAddedModal: this.profileCatFlow === 'new_profile',
        showProfileCategorizationModal: null,
        socialProfile: model,
        socialSetsRemaining: this.socialSetsRemaining,
        removeSocialProfile: this.removeSocialProfile,
        totalSocialSets: this.totalSocialSets
      });
    }

    redirect() {
      if (this.profileCatFlow === 'profile_categorization') {
        this.transitionToExternal('profile_categorization', {
          queryParams: {
            new_profile_type: 'instagram'
          }
        });
      }
    }

    handleUpdate() {
      this.refresh();
    }

    *removeSocialProfile(socialProfile, group) {
      const pages = yield (0, _objectPromiseProxy.arrayPromiseProxy)(group.linkinbioPages);
      const feedBlocks = pages.flatMap(page => {
        var _page$get;

        return page === null || page === void 0 ? void 0 : (_page$get = page.get('linkinbioBlocks')) === null || _page$get === void 0 ? void 0 : _page$get.filterBy('blockType', 'feed');
      }).filter(block => !!block);
      const linkinbioEnabled = feedBlocks.any(block => {
        const id = block.connectedObjectId || block.linkinbioPage.instagramProfile.id;
        return id === socialProfile.id;
      });
      const {
        canMultipleLinkinbioFeeds
      } = this.subscriptions.subscriptionPlan;
      const linkinbioDescription = canMultipleLinkinbioFeeds || !socialProfile.isTiktok ? this.intl.t('account.groups.group.social_profiles.remove.confirm_linkinbio_enabled', {
        name: socialProfile.displayName
      }) : this.intl.t('account.groups.group.social_profiles.remove.confirm_linkinbio_enabled_free_plan', {
        name: socialProfile.displayName
      });
      const description = linkinbioEnabled ? linkinbioDescription : this.intl.t('account.groups.group.social_profiles.remove.confirm', {
        name: socialProfile.displayName
      });
      yield this.dialogManager.confirm(this.intl.t('account.groups.group.social_profiles.remove.confirm_title'), {
        description,
        confirmButton: this.intl.t('shared_words.remove')
      });

      try {
        const socialIdentity = yield (0, _objectPromiseProxy.objectPromiseProxy)(socialProfile.get('socialIdentity'));
        const {
          alert
        } = yield this.settings.submitForm.perform(_classPrivateMethodGet(this, _destroySocialProfile, _destroySocialProfile2).call(this, socialProfile), 'account.groups.group.social_profiles.remove');

        if (socialIdentity.get('socialProfiles').length == 0) {
          group.get('socialIdentities').removeObject(socialIdentity);
        }

        group.get('socialProfiles').removeObject(socialProfile);
        this.send('handleUpdate');
        this.alerts.add(alert);
      } catch ({
        alert
      }) {
        this.alerts.add(alert);
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "credentialStatus", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hasAuthedNewSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "newSocialProfile", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSocialProfile", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "removeSocialProfile"), _class.prototype)), _class);
  _exports.default = SocialProfilesRoute;

  function _destroySocialProfile2(socialProfile) {
    socialProfile.deleteRecord();
    return socialProfile.save();
  }
});